<template>
    <div>
        <left_panel_performance_table :performance="this.performance" title="Today's performance"/>
    </div>
</template>
<script>

    import left_panel_performance_table from '@/components/dashboard/sections/left_panel_performance_table.vue';

    export default {    
        components: {
            left_panel_performance_table
        }, 
        mounted() {
            this.load(); 
        },            
        data() {
            return {
                performance: {},
            }
        },           
        methods: {       
            load(){
                console.log('(re) load left panel performance data');
                this.$axios
                    .post("ares/json/ares/syst/dashboard/getLeftPanelPerformancev1.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getPerformance"
                        },
                        getPerformance: {}
                    })
                    .then(res => {
                        res.data.error ? console.log(res.data.error) : this.performance = res.data.getPerformance;
                    });
            },       
       }        
    }
</script>
